import { useState } from "react";
import { Box, Button, Tooltip } from "@mui/material";
import AppModal from "../../common/AppModal";
import AppSnackbar from "../../common/AppSnackbar";
import ToolbarButton from "../../common/Toolbar-button";
import EditIcon from "../../IconComp/editIcon";
import OrderEditIcon from "../../IconComp/orderAddIcon";
import RestorIcon from "../../IconComp/restorIcon";
import EditBatchModal from "./batch-edit-model";
import usePermissions from "../../../hooks/usePermissions";
import ProductHistoryModal from "./product-history-model";
import ReminderModal from "./reminder-model";
import RestockBatchModal from "./restock-batch-model";

interface IProps {
  batch: any;
  isEdit: boolean;
  setExpireMedCount?: any;
  setNearExpireMedCount?: any;
  order?: any;
  type?: any;
  handleOpenModalRestock?: any;
  getMedicine?: any;
}

export const EditBatchToolbar = ({
  batch,
  isEdit,
  setExpireMedCount,
  setNearExpireMedCount,
  order,
  type,
  handleOpenModalRestock,
  getMedicine,
}: IProps) => {
  const isPermissions = usePermissions();
  const [openModal, setOpenModal] = useState(false);
  const [openRestockModal, setOpenRestockModal] = useState(false);
  const [openRestockBatchModal, setOpenRestockBatchModal] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [selectedMedicineId, setSelectedMedicineId] = useState<any>();
  const handleOpenModal = (medicineId: number) => {
    setSelectedMedicineId(medicineId);
    setOpenModal(true);
  };
  const handleCloseModal = () => setOpenModal(false);
  const handleOpenRestockModal = (medicineId: number) => {
    setSelectedMedicineId(medicineId);
    setOpenRestockModal(true);
  };
  const handleCloseRestockModal = () => setOpenRestockModal(false);
  const handleOpenRestockBatchModal = (medicineId: number) => {
    setSelectedMedicineId(medicineId);
    setOpenRestockBatchModal(true);
  };
  const handleCloseRestockBatchModal = () => setOpenRestockBatchModal(false);
  const Account_Type = parseInt(
    localStorage.getItem("pharmacy_account_type") || "0",
    10
  );
  const [openReminder, setOpenReminder] = useState(false);
  const [selectedBatch, setSelectedBatch] = useState<any>(null);

  return (
    <>
      {isEdit ? (
        <Tooltip
          arrow
          title={
            type === "restock"
              ? "Restock Batch"
              : type === "edit" && order
              ? "Add Batch"
              : "Edit"
          }
        >
          <Box
            sx={{
              alignItems: "center",
              display: "flex",
              justifyContent: "flex-end",
              flexWrap: "wrap",
            }}
          >
            {type === "restock" ? (
              <RestorIcon
                onClick={() => handleOpenRestockModal(batch?.medicine_id)}
              />
            ) : type === "edit" && order ? (
              <OrderEditIcon
                onClick={() => handleOpenModal(batch?.medicine_id)}
              />
            ) : (
              <EditIcon onClick={() => handleOpenModal(batch?.medicine_id)} />
            )}
          </Box>
        </Tooltip>
      ) : order ? (
        <Tooltip arrow title="Add Batch">
          <span
            style={{
              display: "inline-flex",
              alignItems: "center",
              cursor: "pointer",
            }}
          >
            <OrderEditIcon
              onClick={() => handleOpenModal(batch?.medicine_id)}
            />
          </span>
        </Tooltip>
      ) : (
        <Box
          sx={{
            alignItems: "center",
            display: "flex",
            flexWrap: "wrap",
            py: 2,
            "@media (min-width: 1200px) and (max-width: 1281px)": {
              width: "150px",
            },
            "@media (min-width: 769px) and (max-width: 971px)": {
              width: "150px",
            },
            "@media (min-width: 1000px) and (max-width: 1005px)": {
              width: "150px",
            },
          }}
        >
          {(isPermissions?.add && Account_Type === 1) || Account_Type === 0 ? (
            <ToolbarButton
              title={"Add New Batch"}
              handleOpenModal={handleOpenModal}
            />
          ) : null}
        </Box>
      )}
      <AppModal
        title={isEdit ? "Edit Batch" : "Add Batch"}
        open={openModal}
        handleClose={handleCloseModal}
        fullScreen={false}
        maxWidth="md"
      >
        <EditBatchModal
          handleClose={handleCloseModal}
          setOpenSnackbar={() => setOpenSnackbar(true)}
          batch={batch}
          isEdit={isEdit}
          setExpireMedCount={setExpireMedCount}
          setNearExpireMedCount={setNearExpireMedCount}
          selectedMedicineId={selectedMedicineId}
          getMedicine={getMedicine}
        />
      </AppModal>
      <AppModal
        title="Product History"
        open={openRestockModal}
        handleClose={handleCloseRestockModal}
        fullScreen={false}
        maxWidth="md"
      >
        <ProductHistoryModal
          selectedMedicineId={selectedMedicineId}
          setOpenRestockModal={setOpenRestockModal}
          setOpenReminder={setOpenReminder}
          openReminder={openReminder}
          setSelectedBatch={setSelectedBatch}
        />
      </AppModal>
      <AppModal
        title="Restock Batch"
        open={openRestockBatchModal}
        handleClose={handleCloseRestockBatchModal}
        fullScreen={false}
        maxWidth="sm"
      >
        <RestockBatchModal
          selectedMedicineId={selectedMedicineId}
          setOpenRestockBatchModal={setOpenRestockBatchModal}
          setOpenReminder={setOpenReminder}
          openReminder={openReminder}
          selectedBatch={selectedBatch}
          getMedicine={getMedicine}
        />
      </AppModal>
      <ReminderModal
        open={openReminder}
        onClose={() => setOpenReminder(false)}
        onContinue={() => {
          setOpenReminder(false);
          setOpenRestockBatchModal(true);
        }}
      />
      <AppSnackbar
        message={isEdit ? "Successfully Updated!" : "Successfully Added!"}
        open={openSnackbar}
        handleClose={() => setOpenSnackbar(false)}
      />
    </>
  );
};
